<template>
  <div class="w-full">
    <el-dialog :visible.sync="centerDialogVisibleprimary" width="45%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Primary Logo
        </h3></template
      >

      <div class="p-3">
        <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :accept="['image/jpg', 'image/jpeg', 'image/png']"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>

        <div class="grid grid-cols-3 items-center gap-6 mt-4">
          <div
            class="img_wrap"
            v-for="(item, index) in Fetchedmedias"
            :key="('item-', +index)"
            @click="primaryclick(item)"
            v-show="item.type !== 'video'"
          >
            <img
              :src="url1 + item.link"
              alt="image"
              class="w-full object-cover rounded-4px h-72px cursor-pointer"
            />

            <div class="previewselect" v-if="PrimaryLogoMedia._id == item._id">
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-8 h-8"
                class="text-success font-semibold"
              />
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="100"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="centerDialogVisiblealternate" width="45%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Alternate Logo
        </h3></template
      >
      <div class="p-3">
        <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :accept="['image/jpg', 'image/jpeg', 'image/png']"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>
        <div class="grid grid-cols-3 items-center gap-4 mt-4">
          <div
            class="img_wrap"
            v-for="(item, index) in Fetchedmedias"
            :key="('item-', +index)"
            @click="alternateclick(item)"
            v-show="item.type != 'video'"
          >
            <div>
              <div>
                <img
                  :src="url1 + item.link"
                  alt="image"
                  class="w-full object-cover rounded-4px h-72px cursor-pointer"
                />
              </div>
            </div>

            <div
              class="previewselect"
              v-if="AlternateLogoMedia._id == item._id"
            >
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-8 h-8"
                class="text-success font-semibold"
              />
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="100"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="centerDialogVisiblefavicon" width="45%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Favicon Logo
        </h3></template
      >
      <div class="p-3">
        <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :accept="['image/jpg', 'image/jpeg', 'image/png']"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>
        <div class="grid grid-cols-3 items-center gap-4 mt-4">
          <div
            class="img_wrap"
            v-for="(item, index) in Fetchedmedias"
            :key="('item-', +index)"
            @click="faviconclick(item)"
            v-show="item.type != 'video'"
          >
            <div>
              <div>
                <img
                  :src="url1 + item.link"
                  alt="image"
                  class="w-full object-cover rounded-4px h-72px cursor-pointer"
                />
              </div>
            </div>

            <div class="previewselect" v-if="FaviconMedia._id == item._id">
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-8 h-8"
                class="text-success font-semibold"
              />
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="100"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <div class="flex w-full mb-6">
      <h1 class="text-xl text-dark mb-0 mr-1 font-semibold">BrandProfile</h1>

      <div
        v-tooltip.top="{
          content:
            'Define  visual identity of your brand and messaging style on the platform',
          class: 'toolcust',
        }"
      >
        <feather-icon
          icon="InfoIcon"
          class="ml-1 text-grey flex cursor-pointer"
          svgClasses="w-5 h-5"
        />
      </div>
      <h1
        class="text-xl text-primary mb-0 font-semibold cursor-pointer"
        v-if="this.editBrand === true"
        @click="isProfileDetails = false"
      >
        Edit Profile
      </h1>
    </div>

    <div class="py-3 pr-4" v-if="!isProfileDetails">
      <div class="flex justify-between">
        <div class="w-2/3">
          <div class="grid grid-cols-3">
            <div class="flex w-full gap-4 mb-4 relative">
              <div
                class="relative z-10 cursor-pointer"
                @click="centerDialogVisibleprimary = true"
              >
                <img
                  :src="
                    primarySrc
                      ? primarySrc
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="rounded-full w-16 h-16"
                />

                <!-- <div class="absolute new-hew bottom-0 z-50 right-0">
              <input
                type="file"
                ref="fileInput1"
                @change="uploadImages($event, 'primary')"
                class="opacityu"
              />
            </div>
            <div class="absolute bottom-0 z-30 right-0">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/up.png"
                class=""
              />
            </div> -->
              </div>
              <div class="w-9/12 mt-2 pr-4">
                <div>
                  <h2 class="text-dark fsize14 font-semibold mb-0">
                    Primary Logo
                  </h2>
                  <p class="fsize10 text-8f8f8f flex items-center pt-1">
                    Logo for Lighter
                  </p>
                </div>
              </div>
            </div>
            <div
              class="flex w-full gap-4 mb-4 cursor-pointer"
              @click="centerDialogVisiblealternate = true"
            >
              <div class="relative z-10">
                <img
                  :src="
                    secondarySrc
                      ? secondarySrc
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="rounded-full w-16 h-16"
                />
                <!-- <div class="absolute new-hew bottom-0 z-50 right-0">
              <input
                type="file"
                ref="fileInput2"
                @change="uploadImages($event, 'secondary')"
                class="opacityu"
              />
            </div>
            <div class="absolute bottom-0 z-30 right-0">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/up.png"
                class=""
              />
            </div> -->
              </div>
              <div class="w-9/12 pr-4 mt-2">
                <div>
                  <h2 class="text-dark fsize14 font-semibold mb-0">
                    Alternate Logo
                  </h2>
                  <p class="fsize10 text-8f8f8f flex items-center pt-1">
                    Logo for Lighter backgound
                  </p>
                </div>
              </div>
            </div>
            <div
              class="flex w-full mb-4 gap-4 cursor-pointer"
              @click="centerDialogVisiblefavicon = true"
            >
              <div class="relative">
                <img
                  :src="
                    tertiarySrc
                      ? tertiarySrc
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="rounded-full w-16 h-16"
                />
                <!-- <div class="absolute new-hew bottom-0 z-50 right-0">
              <input
                type="file"
                ref="fileInput3"
                @change="uploadImages($event, 'tertiary')"
                class="opacityu"
              />
            </div>
            <div class="absolute bottom-0 z-30 right-0">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/up.png"
                class=""
              />
            </div> -->
              </div>
              <div class="w-9/12 pr-4 mt-2">
                <div>
                  <h2 class="text-dark fsize14 font-semibold mb-0">Favicon</h2>
                  <p class="fsize10 text-8f8f8f flex items-center pt-1">
                    Logo for Lighter backgound
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-10">
            <div class="mb-4">
              <h1 class="text-xl text-dark mb-0 font-semibold">
                Business Niche
              </h1>

              <!-- <p class="text-black pt-1">
            Enter your business details to be displayed through your digital
            presence
          </p> -->
            </div>

            <div class="grid grid-cols-1 gap-3">
              <div class="input-field mt-2">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Business Category</small
                >
                <el-select
                  v-model="businessCategory"
                  placeholder="Select"
                  class="w-full mt-2"
                  value-key="_id"
                  filterable
                >
                  <el-option
                    v-for="item in businessSuites"
                    :key="item._id"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="mt-6">
            <h1 class="text-xl text-dark mb-0 font-semibold">Business Font</h1>
            <div class="grid grid-cols-2 gap-3">
              <div class="input-field mt-2">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Title Font <span class="text-danger">*</span></small
                >
                <el-select
                  v-model="primaryFont"
                  placeholder="Select"
                  class="w-full mt-2"
                  filterable
                >
                  <el-option
                    v-for="item in googleFontFamily"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ primaryFont === "" ? "This Field is required" : "" }}
                </p>
              </div>
              <div class="input-field mt-2">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Sub Title & Paragraph Font
                  <span class="text-danger">*</span></small
                >
                <el-select
                  v-model="secondaryFont"
                  placeholder="Select"
                  class="w-full mt-2"
                  filterable
                >
                  <el-option
                    v-for="item in googleFontFamily"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ secondaryFont === "" ? "This Field is required" : "" }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-6">
            <h1 class="text-xl text-dark mb-0 font-semibold">Business Color</h1>

            <div class="grid grid-cols-3 gap-3 mt-2">
              <div class="input-field">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Primary Color <span class="text-danger">*</span></small
                >

                <div class="relative mt-2">
                  <el-input
                    type="text"
                    id="name"
                    v-model="primaryColor"
                    required
                    placeholder="Hex or rgba"
                    class="inputstyle"
                  />

                  <input
                    type="color"
                    class="colordesign"
                    v-model="primaryColor"
                  />
                </div>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ primaryColor === "" ? "This Field is required" : "" }}
                </p>
              </div>
              <div class="input-field">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Secondary Color <span class="text-danger">*</span></small
                >

                <div class="relative mt-2">
                  <el-input
                    type="text"
                    id="name"
                    v-model="secondaryColor"
                    required
                    placeholder="Hex or rgba"
                    class="inputstyle"
                  />

                  <input
                    type="color"
                    class="colordesign"
                    v-model="secondaryColor"
                  />
                  <p v-if="submitted == true" class="fsize12 text-danger">
                    {{ secondaryColor === "" ? "This Field is required" : "" }}
                  </p>
                </div>
              </div>
              <div class="input-field">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Tertiary Color <span class="text-danger">*</span></small
                >

                <div class="relative mt-2">
                  <el-input
                    type="text"
                    id="name"
                    v-model="tertiaryColor"
                    required
                    placeholder="Hex or rgba"
                    class="inputstyle"
                  />

                  <input
                    type="color"
                    class="colordesign"
                    v-model="tertiaryColor"
                  />
                  <p v-if="submitted == true" class="fsize12 text-danger">
                    {{ tertiaryColor === "" ? "This Field is required" : "" }}
                  </p>
                </div>
              </div>
              <div class="input-field">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Success Color</small
                >

                <div class="relative mt-2">
                  <el-input
                    type="text"
                    id="name"
                    v-model="successColor"
                    required
                    placeholder="Hex or rgba"
                    class="inputstyle"
                  />

                  <input
                    type="color"
                    class="colordesign"
                    v-model="successColor"
                  />
                </div>
              </div>
              <div class="input-field">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Warnning Color</small
                >

                <div class="relative mt-2">
                  <el-input
                    type="text"
                    id="name"
                    v-model="warningColor"
                    required
                    placeholder="Hex or rgba"
                    class="inputstyle"
                  />

                  <input
                    type="color"
                    class="colordesign"
                    v-model="warningColor"
                  />
                </div>
              </div>
              <div class="input-field">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Danger Color</small
                >

                <div class="relative mt-2">
                  <el-input
                    type="text"
                    id="name"
                    v-model="dangerColor"
                    required
                    placeholder="Hex or rgba"
                    class="inputstyle"
                  />

                  <input
                    type="color"
                    class="colordesign"
                    v-model="dangerColor"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-1/3 ml-8">
          <div class="bg-white shadow-md rounded-lg p-4 border">
            <div>
              <div class="w-full">
                <iframe :srcdoc="html" class="w-full new-zee" height="250px">
                </iframe>
              </div>
              <!-- <h2 class="text-xl text-primary font-semibold">
                Business Details Preview
              </h2>

              <p class="mt-6 text-gray-200">Primary Font</p>
              <h1
                class="mt-3 font-bold"
                :style="{ 'font-family': primaryFont }"
              >
                This is Heading
              </h1>
              <p class="mt-6 text-gray-200">Secondary Font</p>
              <p
                class="mt-3 text-black"
                :style="{ 'font-family': secondaryFont }"
              >
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Adipisci doloremque est, nihil earum ut placeat necessitatibus
                eos itaque maxime dolore minus alias neque provident, numquam
                sint nam aperiam. Cumque, sit.
              </p> -->
              <p class="mt-6 text-gray-200">Brand color</p>
              <div class="mt-3">
                <div class="grid grid-cols-3 w-full gap-8">
                  <div
                    class="p-4 flex justify-center items-center h-16 rounded-lg"
                    :style="{ 'background-color': primaryColor }"
                  >
                    <p class="text-sm text-white">Primary</p>
                  </div>
                  <div
                    class="p-4 flex justify-center items-center h-16 rounded-lg"
                    :style="{ 'background-color': secondaryColor }"
                  >
                    <p class="text-sm text-white">Secondary</p>
                  </div>
                  <div
                    class="p-4 flex justify-center items-center h-16 rounded-lg"
                    :style="{ 'background-color': tertiaryColor }"
                  >
                    <p class="text-sm text-white">Tertiary</p>
                  </div>
                </div>

                <div class="grid grid-cols-3 w-full gap-8">
                  <div
                    class="p-4 mt-4 flex justify-center items-center h-16 rounded-lg"
                    :style="{ 'background-color': successColor }"
                  >
                    <p class="text-sm text-white">Success</p>
                  </div>
                  <div
                    class="p-4 mt-4 flex justify-center items-center h-16 rounded-lg"
                    :style="{ 'background-color': warningColor }"
                  >
                    <p class="text-sm text-white">Warning</p>
                  </div>
                  <div
                    class="p-4 mt-4 flex justify-center items-center h-16 rounded-lg"
                    :style="{ 'background-color': dangerColor }"
                  >
                    <p class="text-sm text-white">Danger</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="py-5">
        <div class="border-round pt-10 pb-4 relative">
          <h1 class="fsize20 text-primary mb-0 font-semibold">
            Business Details
          </h1>
          <p class="text-black pt-1">
            Enter your business details to be displayed through your digital
            presence
          </p>

          <div class="grid grid-cols-3 gap-8 mt-6">
            <div class="mb-8">
              <h1 class="text-xl text-dark font-semibold">Business Details</h1>

              <div>
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium">
                    Contact Number <span class="text-danger">*</span></small
                  >
                  <vue-tel-input
                    :disabledFormatting="true"
                    :enabledCountryCode="true"
                    v-model="mobile"
                    placeholder="Enter phone no"
                    name="Contact no"
                    :required="true"
                    :autoDefaultCountry="true"
                    class="w-full mt-2 h-40px rounded-xl div-autowidth"
                    v-validate="'required|numeric|max:10'"
                    data-vv-validate-on="input|blur"
                    :defaultCountry="
                      `${this.countryC}` ? `${this.countryC}` : 'IN'
                    "
                    :showFlags="true"
                    :disabledFetchingCountry="true"
                    ref="countryCode"
                    :key="countryC"
                    :showFlag="true"
                    @country-changed="getCountry"
                  />
                  <p v-if="submitted == true" class="fsize12 text-danger">
                    {{ mobile === "" ? "This Field is required" : "" }}
                  </p>
                </div>

                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Website URL <span class="text-danger">*</span></small
                  >
                  <el-input
                    type="text"
                    placeholder="example@businessname.com"
                    id="name"
                    v-model="url"
                    class="mt-2"
                    required
                  />
                </div>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ url === "" ? "This Field is required" : "" }}
                </p>
              </div>
              <div class="">
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Business Email <span class="text-danger">*</span></small
                  >
                  <el-input
                    type="text"
                    placeholder="example@businessname.com"
                    id="name"
                    v-model="email"
                    class="mt-2"
                    required
                  />
                  <p v-if="submitted == true" class="fsize12 text-danger">
                    {{ email === "" ? "This Field is required" : "" }}
                  </p>
                </div>
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >GSTIN</small
                  >
                  <el-input
                    class="w-full mt-2"
                    type="text"
                    v-model="GSTNumber"
                    placeholder="Enter..."
                    id="name"
                    required
                  />
                  <p
                    v-if="GSTNumber && submitted == true"
                    class="fsize12 text-danger"
                  >
                    {{
                      regexCheck === false
                        ? "Please fill proper GST number"
                        : ""
                    }}
                  </p>
                </div>
              </div>
              <div class="">
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Business Address <span class="text-danger">*</span></small
                  >
                  <el-input
                    class="w-full mt-1 h128pxel"
                    type="textarea"
                    v-model="address"
                    placeholder="Enter your business address"
                    id="name"
                    required
                  />
                  <p v-if="submitted == true" class="fsize12 text-danger">
                    {{ address === "" ? "This Field is required" : "" }}
                  </p>
                </div>

                <div class="input-field mt-4">
                  <div class="flex items-center">
                    <small class="fsize12 bg-white text-dark font-medium"
                      >Bank details to receive payments
                    </small>
                    <el-popover
                      placement="top-start"
                      popper-class="fsize12 p-4"
                      width="200"
                      trigger="hover"
                      content="These details are attached to the customer invoices"
                    >
                      <feather-icon
                        slot="reference"
                        icon="InfoIcon"
                        class="cursor-pointer ml-2 flex"
                        svgClasses="w-4 h-4"
                      />
                    </el-popover>
                  </div>

                  <el-input
                    class="w-full mt-2 h128pxel"
                    type="textarea"
                    v-model="bankDetails"
                    placeholder="Enter..."
                    id="name"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="mb-8">
              <h1 class="text-xl text-dark font-semibold">Social Media</h1>
              <div>
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium">
                    Instagram</small
                  >
                  <el-input
                    type="text"
                    placeholder="Profile Link"
                    id="name"
                    v-model="instagram"
                    class="mt-2"
                    required
                  />
                </div>
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium">
                    Facebook</small
                  >
                  <el-input
                    type="text"
                    placeholder="Profile Link"
                    id="name"
                    v-model="facebook"
                    class="mt-2"
                    required
                  />
                </div>
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium">
                    Whatsapp</small
                  >
                  <el-input
                    type="text"
                    placeholder="Profile Link"
                    id="name"
                    v-model="whatsapp"
                    class="mt-2"
                    required
                  />
                </div>
              </div>
              <div class="">
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium">
                    Linkedin</small
                  >
                  <el-input
                    type="text"
                    placeholder="Profile Link"
                    id="name"
                    v-model="linkedin"
                    class="mt-2"
                    required
                  />
                </div>
                <div class="input-field mt-4">
                  <small class="fsize12 bg-white text-dark font-medium">
                    Pinterest</small
                  >
                  <el-input
                    type="text"
                    placeholder="Profile Link"
                    id="name"
                    v-model="pinterest"
                    class="mt-2"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="mb-8">
              <h1 class="text-xl text-dark font-semibold">Active Hours</h1>
              <!-- <p class="fsize14 col-4f mb-0 opacity-80">
                Specify your working Hours
              </p> -->
              <div class="relative mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Select a Timezone</small
                >
                <el-select
                  v-model="timezone"
                  placeholder="Select"
                  filterable
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="`${index}-${item.name}`"
                    :label="`${item.name} ` + ' ' + ` ${item.zone}`"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="grid grid-cols-7 mt-4 checkj">
                <div class="">
                  <el-checkbox v-model="sunday">su</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="monday">Mo</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="tuesday">Tu</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="wednesday">W</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="thursday">Th</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="friday">Fr</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="saturday">sa</el-checkbox>
                </div>
              </div>
              <div class="mt-8 flex">
                <div class="w-1/2 pr-2">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Open from</small
                  >
                  <el-time-select
                    class="w-full mt-2"
                    placeholder="Start time"
                    v-model="from"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '23:59',
                    }"
                  >
                  </el-time-select>
                </div>
                <div class="w-1/2 pl-2">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Closes at</small
                  >
                  <el-time-select
                    class="w-full mt-2"
                    placeholder="End time"
                    v-model="to"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '23:59',
                      minTime: from,
                    }"
                  >
                  </el-time-select>
                </div>
              </div>

              <div class="mt-6">
                <h4 class="text-xl text-dark mb-0 font-semibold">Gallery</h4>
                <div class="grid grid-cols-10 gap-4 mt-4">
                  <div
                    class="img_wrap cursor-pointer relative"
                    v-for="(item, index) in imgCollection"
                    :key="('item-', +index)"
                    @click="selectLayout(item)"
                  >
                    <img
                      :src="item.img"
                      alt="image"
                      class="w-full object-cover rounded-4px cursor-pointer"
                    />

                    <div
                      v-if="selectedLayout.img == item.img"
                      class="previewselect"
                    >
                      <feather-icon
                        icon="CheckIcon"
                        svgClasses="w-8 h-8"
                        class="text-success font-semibold"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 flex justify-center">
            <vs-button
              variant="primary"
              class="px-16 py-4 font-medium rounded-full"
              @click="updateProfile()"
            >
              Submit
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="" v-show="isProfileDetails">
      <iframe
        width="100%"
        height="5000px"
        class="rounded-6px"
        :src="pdfLink"
      ></iframe>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import time from "moment-timezone";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

export default {
  data() {
    return {
      centerDialogVisibleprimary: false,
      centerDialogVisiblealternate: false,
      centerDialogVisiblefavicon: false,
      isProfileDetails: false,
      mobile: "",
      saturday: false,
      friday: false,
      thursday: false,
      wednesday: false,
      tuesday: false,
      monday: false,
      sunday: false,
      input: "",
      pinterest: "",
      linkedin: "",
      whatsapp: "",
      facebook: "",
      instagram: "",
      address: "",
      email: "",
      html: "",
      successColor: "",
      warningColor: "",
      dangerColor: "",
      primaryColor: "",
      secondaryColor: "",
      tertiaryColor: "",
      brand: "",
      filteredData: [],
      primaryFont: "",
      secondaryFont: "",
      projectName: "",
      mobileNumber: "",
      businessCategory: {},
      bankDetails: "",
      GSTNumber: "",
      from: "",
      to: "",
      timezone: "",
      weekDays: "",
      primaryLogo: null,
      primarySrc: "",
      secondaryLogo: null,
      secondarySrc: "",
      tertiaryLogo: null,
      tertiarySrc: "",
      countryC: "",
      completed: false,
      originalFiles: "",
      files: [],
      showPreview: false,
      submitted: false,
      PrimaryLogoMedia: {},
      AlternateLogoMedia: {},
      FaviconMedia: {},
      regexCheck: false,
      imgCollection: [
        {
          id: "01",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/1.png",
          layout: [0, 2, 3, 5, 6, 8],
        },
        {
          id: "02",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/2.png",
          layout: [0, 2, 4, 6, 8],
        },
        {
          id: "03",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/3.png",
          layout: [0, 1, 2, 6, 7, 8],
        },
        {
          id: "04",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/4.png",
          layout: [1, 4, 7],
        },

        {
          id: "05",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/5.png",
          layout: [3, 4, 5],
        },
        {
          id: "06",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/6.png",
          layout: [0, 1, 2, 6, 7, 8],
        },

        {
          id: "07",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/7.png",
          layout: [0, 2, 6, 8],
        },
        {
          id: "08",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/8.png",
          layout: [0, 1, 3, 4, 6, 7],
        },
        {
          id: "09",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/9.png",
          layout: [0, 4, 8],
        },

        {
          id: "10",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/10.png",
          layout: [1, 3, 5, 7],
        },
      ],
      options: [],
      pdfLink: "",
      Fetchedmedias: [],
      url: "",
      url1: this.$imageURL + "/",
      editBrand: false,
      selectedLayout: {},
    };
  },
  components: {
    VueTelInput,
  },
  watch: {
    primaryFont() {
      this.iframeTemplate();
    },
    secondaryFont() {
      this.iframeTemplate();
    },
    dangerColor(val) {
      if (!val) {
        this.dangerColor = "#d64c4c";
      }
    },
    successColor(val) {
      if (!val) {
        this.successColor = "#2BC370";
      }
    },
    warningColor(val) {
      if (!val) {
        this.warningColor = "#e37a16";
      }
    },
  },
  computed: {
    ...mapState("brandProfile", [
      "brandProfile",
      "googleFontFamily",
      "layoutSelected",
    ]),
    ...mapState("brandProfile", ["businessSuites"]),
    ...mapState("user", ["selectedProject"]),
    success() {
      return (this.successColor = this.successColor
        ? this.successColor
        : "#2BC370");
    },
    warning() {
      return this.warningColor ? this.warningColor : "#cbce0d";
    },
  },
  methods: {
    alternateclick(item) {
      this.AlternateLogoMedia = item;
      if (this.AlternateLogoMedia != {}) {
        this.secondarySrc = this.url1 + this.AlternateLogoMedia.link;
        this.secondaryLogo = this.AlternateLogoMedia.link;
        this.centerDialogVisiblealternate = false;
      }
    },
    iframeTemplate() {
      this.html = `
        <!DOCTYPE html>
        <html>
        <head>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=${this.primaryFont}|${this.secondaryFont}">
        </head>
        <body>
          <div class="mt-32 flex w-full">
            <div class="w-3/12 p-2">
                <div>
                  <p class="fsize20 font-semibold col-4f mb-0 cross">Preview</p>
                </div>
              </div>
              <div class="w-9/12 p-4">
                <h1  style="font-family:${this.primaryFont};" class="text-4xl mb-0 col-4f font-semibold">
                  This is a Heading
                </h1>
                <p style="font-family:${this.secondaryFont};"  class="fsize16 col-4f mb-0">
                    Finally this is an example of how<br />
                    your paragraphs will look like with<br />
                    this your design preferences:)
                </p>
              </div>
            </div>
          </div>
        </body>
        </html>`;
    },
    primaryclick(item) {
      this.PrimaryLogoMedia = item;
      if (this.PrimaryLogoMedia != {}) {
        this.primarySrc = this.url1 + this.PrimaryLogoMedia.link;
        this.primaryLogo = this.PrimaryLogoMedia.link;
        this.centerDialogVisibleprimary = false;
      }
    },
    faviconclick(item) {
      this.FaviconMedia = item;
      if (this.FaviconMedia != {}) {
        this.tertiaryLogo = this.FaviconMedia.link;
        this.tertiarySrc = this.url1 + this.FaviconMedia.link;
        this.centerDialogVisiblefavicon = false;
      }
    },
    selectLayout(item) {
      this.selectedLayout = item;
      this.$store.commit("brandProfile/SET_LAYOUT", item);
    },
    async getBrandProfile() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      await this.$store.dispatch("brandProfile/getBrandProfile", payload);
      this.brand = this.brandProfile;
    },
    async updateProfile() {
      let payload = {
        projectId: this.brand.projectId,
        projectName: this.projectName,
      };

      let imagePayload = {};
      this.primaryLogo = this.PrimaryLogoMedia.link
        ? this.PrimaryLogoMedia.link
        : this.primaryLogo;
      this.secondaryLogo = this.AlternateLogoMedia.link
        ? this.AlternateLogoMedia.link
        : this.secondaryLogo;
      this.tertiaryLogo = this.FaviconMedia.link
        ? this.FaviconMedia.link
        : this.tertiaryLogo;
      if (this.GSTNumber != this.brand.GSTNumber) {
        Object.assign(payload, { GSTNumber: this.GSTNumber });
      }
      if (this.businessCategory != this.brand.businessCategory) {
        Object.assign(payload, { businessCategory: this.businessCategory });
      }
      if (this.primaryLogo) {
        Object.assign(imagePayload, { primaryLogo: this.primaryLogo });
      }
      if (this.secondaryLogo) {
        Object.assign(imagePayload, { alternateLogo: this.secondaryLogo });
      }
      if (this.tertiaryLogo) {
        Object.assign(imagePayload, { favIcon: this.tertiaryLogo });
      }
      if (this.primaryFont != this.brand.primaryFont) {
        Object.assign(payload, { primaryFont: this.primaryFont });
      }
      if (this.secondaryFont != this.brand.secondaryFont) {
        Object.assign(payload, { secondaryFont: this.secondaryFont });
      }
      if (this.primaryColor != this.brand.primaryColor) {
        Object.assign(payload, { primaryColor: this.primaryColor });
      }
      if (this.secondaryColor != this.brand.secondaryColor) {
        Object.assign(payload, { secondaryColor: this.secondaryColor });
      }
      if (this.tertiaryColor != this.brand.tertiaryColor) {
        Object.assign(payload, { tertiaryColor: this.tertiaryColor });
      }
      if (this.successColor != this.brand.successColor) {
        Object.assign(payload, { successColor: this.successColor });
      }
      if (this.warningColor != this.brand.warningColor) {
        Object.assign(payload, { warningColor: this.warningColor });
      }
      if (this.dangerColor != this.brand.dangerColor) {
        Object.assign(payload, { dangerColor: this.dangerColor });
      }

      if (this.whatsapp != this.brand.contactDetails.whatsapp) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { whatsapp: this.whatsapp });
      }
      if (this.facebook != this.brand.contactDetails.facebook) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { facebook: this.facebook });
      }
      if (this.email != this.brand.contactDetails.email) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { email: this.email });
      }
      if (this.address != this.brand.contactDetails.address) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { address: this.address });
      }
      if (this.instagram != this.brand.contactDetails.instagram) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { instagram: this.instagram });
      }
      if (this.pinterest != this.brand.contactDetails.pinterest) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { pinterest: this.pinterest });
      }
      if (this.linkedin != this.brand.contactDetails.linkedin) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { linkedin: this.linkedin });
      }
      if (this.from != this.brand.contactDetails.from) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { from: this.from });
      }
      if (this.mobile != this.brand.contactDetails.mobile) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { mobile: this.mobile });
      }
      if (this.url != this.brand.contactDetails.url) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { url: this.url });
      }
      if (this.to != this.brand.contactDetails.to) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { to: this.to });
      }
      if (this.timezone != this.brand.contactDetails.timezone) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { timezone: this.timezone });
      }
      if (this.sunday != this.brand.contactDetails.weekDays.sunday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { sunday: this.sunday });
      }
      if (this.monday != this.brand.contactDetails.weekDays.monday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { monday: this.monday });
      }
      if (this.tuesday != this.brand.contactDetails.weekDays.tuesday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { tuesday: this.tuesday });
      }
      if (this.wednesday != this.brand.contactDetails.weekDays.wednesday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, {
          wednesday: this.wednesday,
        });
      }
      if (this.thursday != this.brand.contactDetails.weekDays.thursday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { thursday: this.thursday });
      }
      if (this.friday != this.brand.contactDetails.weekDays.friday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, {
          friday: this.friday,
        });
      }
      if (this.saturday != this.brand.contactDetails.weekDays.saturday) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, { weekDays: true });
        Object.assign(payload, { saturday: this.saturday });
      }
      if (this.code != this.brandProfile.contactDetails.countrycode.iso2) {
        Object.assign(payload, { contactDetails: true });
        Object.assign(payload, {
          countrycode: this.code,
        });
      }
      if (this.selectedLayout != this.brand.Layout) {
        Object.assign(payload, { Layout: this.selectedLayout });
      }

      const formData = new FormData();
      // formData.append("payloadData", JSON.stringify(payload));

      if (imagePayload) {
        let keys = Object.keys(imagePayload);
        let values = Object.values(imagePayload);
        // console.log(keys, values);
        for (let i = 0; i < keys.length; i++) {
          if (
            (keys[i] === "alternateLogo" ||
              keys[i] === "favIcon" ||
              keys[i] === "primaryLogo") &&
            values[i]
          ) {
            formData.append(keys[i], values[i]);
            console.log(keys[i], JSON.stringify(values[i]), "Helloooo");
          }
        }
        console.log(payload, "payload");
        formData.append("payloadData", JSON.stringify(payload));
        // for (const [key, values] of Object.assign(Object.entries(payload))) {
        //   formData.append(`${key}`, ` ${values}`);
        //   console.log(`${key}, ${values}`, "Hello");
        // }
        console.log(this.primarySrc, this.secondarySrc, this.tertiarySrc);
        this.submitted = true;
        const regex = new RegExp(
          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
        );
        let regexData = this.GSTNumber ? regex.test(this.GSTNumber) : true;
        console.log(regexData, "Dattttatatat");
        this.regexCheck = regexData;
        console.log(this.regexCheck, "Hello");
        if (
          this.url !== "" &&
          this.primaryFont !== "" &&
          this.secondaryFont !== "" &&
          this.email !== "" &&
          this.primaryColor !== "" &&
          this.secondaryColor !== "" &&
          this.tertiaryColor !== "" &&
          this.mobile !== "" &&
          this.address !== "" &&
          this.regexCheck
        ) {
          this.isProfileDetails = true;

          await this.$store.dispatch(
            "brandProfile/uploadBrandProfile",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          await this.getBrandProfile();
          await this.getPdf();
        }
      }
    },

    async getPdf() {
      this.editBrand = true;
      let temp1 = this.PrimaryLogoMedia.link
        ? this.url1 + this.PrimaryLogoMedia.link
        : this.primarySrc;
      let temp2 = this.AlternateLogoMedia.link
        ? this.url1 + this.AlternateLogoMedia.link
        : this.secondarySrc;
      let temp3 = this.FaviconMedia.link
        ? this.url1 + this.FaviconMedia.link
        : this.tertiarySrc;
      // console.log(
      //   this.primarySrc,
      //   this.secondarySrc,
      //   this.tertiarySrc,
      //   "Logos"
      // );

      const { data } = await axios.post(
        `${process.env.VUE_APP_BRANDING_API}api/v1/set1/1`,
        {
          fontFamily: [this.primaryFont, this.secondaryFont],
          iconfamily: "Feather icons",
          primary: this.primaryColor,
          secondary: this.secondaryColor,
          Success: this.successColor,
          Danger: this.dangerColor,
          Warning: this.warningColor,
          brandName: this.selectedProject.displayName,
          Brandlogophotos: [temp1, temp2, temp3],
        }
      );
      this.pdfLink = data;
    },

    async uploadImages(event, logo) {
      console.log(event.target.files, logo);
      this.primaryLogo, this.secondaryLogo, this.tertiaryLogo;
      if (logo === "primary") {
        // let blob = new Blob();

        this.primaryLogo = event.target.files[0];
        this.primarySrc = await this.convertToBase64(event.target.files[0]);

        this.showPreview = true;
        console.log(this.primaryLogo);
      }
      if (logo === "secondary") {
        this.secondaryLogo = event.target.files[0];
        this.secondarySrc = await this.convertToBase64(event.target.files[0]);
        this.showPreview = true;
      }
      if (logo === "tertiary") {
        this.tertiaryLogo = event.target.files[0];
        this.tertiarySrc = await this.convertToBase64(event.target.files[0]);
        this.showPreview = true;
      }
    },

    convertToBase64(file) {
      return new Promise(async (resolve, reject) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onloadend = await function () {
          resolve(reader.result);
        };
      });
    },

    getImageURL(file) {
      if (file.size > 0) {
        return `${URL.createObjectURL(file)}`;
      }
    },
    init() {
      this.projectName = this.brand.projectName;
      console.log(this.projectName, "hello");
      //this.Font= this.googleFontFamily,
      this.GSTNumber = this.brand.GSTNumber;
      this.primaryColor = this.brand.primaryColor;
      this.secondaryColor = this.brand.secondaryColor;
      this.tertiaryColor = this.brand.tertiaryColor;
      this.whatsapp = this.brand.contactDetails.whatsapp;
      this.facebook = this.brand.contactDetails.facebook;
      this.successColor = this.brand.successColor
        ? this.brand.successColor
        : "#2BC370";
      this.warningColor = this.brand.warningColor
        ? this.brand.warningColor
        : "#e37a16";
      this.dangerColor = this.brand.dangerColor
        ? this.brand.dangerColor
        : "#EA5455";
      this.primaryFont = this.brand.primaryFont;
      this.secondaryFont = this.brand.secondaryFont;
      this.businessCategory = this.brand.businessCategory;
      this.instagram = this.brand.contactDetails.instagram;
      this.pinterest = this.brand.contactDetails.pinterest;
      this.linkedin = this.brand.contactDetails.linkedin;
      this.url = this.brand.contactDetails.url;
      this.email = this.brand.contactDetails.email;
      this.mobile = this.brand.contactDetails.mobile.toString();
      this.address = this.brand.contactDetails.address;
      this.timezone = this.brand.contactDetails.timezone;
      this.from = this.brand.contactDetails.from;
      this.to = this.brand.contactDetails.to;
      this.sunday = this.brand.contactDetails.weekDays.sunday;
      this.monday = this.brand.contactDetails.weekDays.monday;
      this.tuesday = this.brand.contactDetails.weekDays.tuesday;
      this.wednesday = this.brand.contactDetails.weekDays.wednesday;
      this.thursday = this.brand.contactDetails.weekDays.thursday;
      this.friday = this.brand.contactDetails.weekDays.friday;
      this.saturday = this.brand.contactDetails.weekDays.saturday;
      this.bankDetails = this.brand.bankDetails;
      let text = this.url1 + this.brandProfile.primaryLogo;
      let text2 = this.url1 + this.brandProfile.alternateLogo;
      let text3 = this.url1 + this.brandProfile.favIcon;
      let result = text.includes(`${this.$imageURL}`);
      let result2 = text2.includes(`${this.$imageURL}`);
      let result3 = text3.includes(`${this.$imageURL}`);
      console.log(result, "leftDash");
      if (result === true || result2 === true || result3 === true) {
        this.primarySrc = text;
        this.secondarySrc = text2;
        this.tertiarySrc = text3;
      } else {
        this.primarySrc = `${this.$imageURL}/` + +text;
        this.secondarySrc = `${this.$imageURL}/` + text2;
        this.tertiarySrc = `${this.$imageURL}/` + text3;
      }
      console.log(this.$imageURL, "imageUrl");
      // let result1 = text1.includes(
      //   "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/"
      // );
      // if (result1 === true) {
      //   this.primarySrc = text1.slice(60);
      // }
      // let result2 = text2.includes(
      //   "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/"
      // );
      // if (result2 === true) {
      //   this.secondarySrc = text2.slice(60);
      // }
      // let result3 = text3.includes(
      //   "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/"
      // );
      // if (result3 === true) {
      //   this.tertiarySrc = text3.slice(60);
      // }
      this.countryC = this.brandProfile.contactDetails.countrycode.iso2;
      this.getBrandProfile();
    },
    getTimeZone() {
      let data = time.tz.names();
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        this.options.push({
          name: data[i],
          zone: time.tz(`${data[i]}`).format(`z (Z)`),
        });
      }
    },
    getCountry(country) {
      this.code = country;
    },
    async Fetchmedia() {
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      console.log(this.Fetchedmedias);
    },

    async handleUploadSuccess(name) {
      // this.centerDialogVisiblealternate = false;
      // this.centerDialogVisibleprimary = false;
      // this.centerDialogVisiblefavicon = false;
      this.$swal({
        title: "Success!",
        text: `File ${name} uploaded`,
        icon: "success",
        timer: 2000,
        buttons: false,
      });
    },
    beforeUpload(file) {
      console.log(file.name);
      let formData = new FormData();
      const fileType = file.type;
      formData.append("file", file);
      if (
        fileType.startsWith("image/jpeg") ||
        fileType.startsWith("image/png") ||
        fileType.startsWith("image/gif")
      ) {
        formData.append("type", "image");
      } else if (
        fileType.startsWith("video/mp4") ||
        fileType.startsWith("video/webm") ||
        fileType.startsWith("video/ogg")
      ) {
        formData.append("type", "video");
      } else if (fileType.startsWith("image/svg+xml")) {
        formData.append("type", "svg");
      } else {
        this.isShowDetailsAddons = false;
        this.$swal({
          title: "Error",
          text: `${file.type} not allowed`,
          icon: "error",
          timer: 5000,
          buttons: false,
        });
        return;
      }
      let URL = process.env.VUE_APP_BASE_URL_CORE_API.split("/api/")[0];
      formData.append("Storeendpoint", URL);
      this.uploadFile(formData, file.name);
      return false;
    },
    async uploadFile(formData, name) {
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Save",
        formData,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      this.handleUploadSuccess(name);
    },
  },
  async mounted() {
    this.editBrand = false;
    await this.Fetchmedia();
    this.iframeTemplate();
    console.log(this.Fetchedmedias, "fethcmed");
    this.getTimeZone();
    await this.getBrandProfile();
    await this.init();
    this.getCountry();
    await this.$store.dispatch("brandProfile/getBusinessSuites", {
      show: true,
    });
    if (!Object.keys(this.layoutSelected).keys.length) {
      await this.selectLayout(this.imgCollection[0]);
    }
  },
};
</script>
<style>
.new-zee {
  z-index: 999999 !important;
  position: relative;
}
</style>
